import { render, staticRenderFns } from "./TimeAllocationView.vue?vue&type=template&id=f6b3d906&scoped=true"
import script from "./TimeAllocationView.vue?vue&type=script&lang=js"
export * from "./TimeAllocationView.vue?vue&type=script&lang=js"
import style0 from "./TimeAllocationView.vue?vue&type=style&index=0&id=f6b3d906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b3d906",
  null
  
)

export default component.exports